import { useCallback, useRef } from 'react';
import { OpenFieldPanelRef } from 'models/FieldFocusableModal';

const useChipLabelClickRefs = () => {
  const multiFilterRef = useRef<OpenFieldPanelRef>(null);
  const multiSortRef = useRef<OpenFieldPanelRef>(null);

  const onChipLabelClick = useCallback(
    (fieldKey: string) => multiFilterRef.current?.openField(fieldKey),
    [],
  );

  const onSortChipLabelClick = useCallback(
    (fieldKey: string) => multiSortRef.current?.openField(fieldKey),
    [],
  );

  return {
    multiFilterRef,
    multiSortRef,
    onChipLabelClick,
    onSortChipLabelClick,
  };
};

export default useChipLabelClickRefs;
